import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';

import { Util } from '../_classes/util';
import { Servidor } from './../_classes/servidor';
import { EnvService } from './../_servicos/env.service';
import { FotoService } from './../_servicos/foto.service';
import { ServidorService } from './../_servicos/servidor.service';

@Component({
  selector: 'app-usuario-conectado',
  templateUrl: './usuario-conectado.component.html',
  styleUrls: ['./usuario-conectado.component.scss'],
})
export class UsuarioConectadoComponent implements OnInit, OnDestroy {
  inscricao: Subscription;

  foto = null;

  constructor(
    private _sServ: ServidorService,
    private sanitizer: DomSanitizer,
    private fotoService: FotoService,
    private securityService: KeycloakService,
    private _sEnv: EnvService
  ) {}

  public get servidor(): Servidor {
    return this._sEnv.servidor;
  }

  ngOnInit() {
    if (this._sEnv.servidor) {
      this.listar(this._sEnv.servidor);
    } else {
      this.inscricao = this._sServ.getServidor().subscribe((usr) => {
        this.listar(this._sEnv.servidor);
      });
    }
  }

  listar(s: Servidor) {
    const blob = new Blob(
      [Util.Base64ToBlob(this.fotoService.getFoto(s.idServidor?.toString()))],
      {
        type: 'image/bmp',
      }
    );
    let arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    this.foto = arquivoUrl;
  }

  ngOnDestroy() {
    if (this.inscricao) {
      this.inscricao.unsubscribe();
    }
  }

  sair() {
    this.securityService.logout();
  }
}
